import { Backdrop } from '@material-ui/core';
import type { Placement } from '@popperjs/core';
import classNames from 'clsx';
import React from 'react';

import CoachMark from '@swf/components/CoachMark/CoachMark';

import { useOnboardingContext } from '../OnboardingContext/OnbordingContext';

import styles from './OnboardFlow.scss';

interface Props {
  onBoardStep?: JSX.Element;
  arrowClassName?: string;
  coachMarkClassName?: string;
}
const OnboardFlow: React.FC<Props> = ({ onBoardStep, arrowClassName, coachMarkClassName }) => {
  const { onboardingFinished, refEl, activeStep, steps } = useOnboardingContext();

  return !onboardingFinished ? (
    <>
      <CoachMark
        className={classNames(styles.coachMark, coachMarkClassName)}
        content={onBoardStep}
        placement={steps[activeStep].placement as Placement}
        forwardedRef={refEl ?? undefined}
        classes={arrowClassName ? { arrow: arrowClassName } : undefined}
      />
      <Backdrop open={true} className={styles.backdrop} />
    </>
  ) : null;
};

export default React.memo(OnboardFlow);
